import { render } from "./EventItem.vue?vue&type=template&id=5e7918b4&scoped=true"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"

import "./EventItem.vue?vue&type=style&index=0&id=5e7918b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7918b4"]])

export default __exports__